import { useCallback, useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import { Card, Button, List, ListItem, AppBar, LogoLoader } from 'bf-ui';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

import styles from '../../assets/styles/pages/promotion.page.scss';
import { getPromo_req } from '../../api/promos.api';
import { baseURLV1 } from '../../api/axiosInstance';

import LinkWrapper from '../../components/wrappers/link/link.wrapper';
import { isClient } from '../../helpers/detector.helper';
import { cacheControl } from '../../helpers/cache.helper';

export default function PromotionPage({ data }) {
  const router = useRouter();
  const intl = useIntl();

  const { query, locale } = router;

  const [promo, setPromo] = useState(data);

  const loadPromo = useCallback(async () => {
    if (promo) {
      return;
    }

    try {
      setPromo(await getPromo_req({}, query.promotionKey, locale));
    } catch (e) {
      console.log('PromotionPage -> loadPromo Error:', e);
    }
  }, [promo, locale]);

  useEffect(() => {
    loadPromo();
  }, [promo]);

  const moreWrapperContent = () => {
    if (promo.Href) {
      if (promo.As) {
        return (
          <LinkWrapper href={promo.Href} as={promo.As}>
            <Button variant="contained">{promo.BtnText}</Button>
          </LinkWrapper>
        );
      }

      return (
        <a href={promo.Href}>
          <Button variant="contained">{promo.BtnText}</Button>
        </a>
      );
    }

    if (promo.BtnText) {
      return <Button variant="contained">{promo.BtnText}</Button>;
    }

    return <></>;
  };

  if (!promo) {
    return (
      <>
        <Div100vh id="promotion-page" className="page loading">
          <LogoLoader />
        </Div100vh>
        <style jsx>{styles}</style>
      </>
    );
  }

  return (
    <>
      <div id="promotion-page" className="page">
        <AppBar className="back_bar">
          <LinkWrapper href="/promotions" className="back_wrapper">
            <span className="icon-back" />
          </LinkWrapper>
          <h1>{intl.messages.promotions}</h1>
        </AppBar>
        <div className="content">
          <Card key={promo.ID}>
            <div className="card_header">
              <img src={`${baseURLV1}/media/${promo.MediaID}`} alt={promo.ID} />
              <h2>{promo.Title}</h2>
              {promo.FullDesc && (
                <div dangerouslySetInnerHTML={{ __html: promo.FullDesc }} />
              )}
            </div>

            {promo.BigDesc && (
              <p
                className="big_desc"
                dangerouslySetInnerHTML={{ __html: promo.BigDesc }}
                style={{
                  backgroundColor: promo.BigDescColor || '#8a00c4',
                }}
              />
            )}
            {promo.Games?.length ? (
              <div className="games_wrapper">
                <h3>Games</h3>
                <List>
                  {promo.Games.map((game) => (
                    <ListItem key={game.Key}>
                      <LinkWrapper
                        href={`/games/${game.Key}`}
                        as={`/games/${game.Key}`}
                      >
                        {game.Name}
                      </LinkWrapper>
                    </ListItem>
                  ))}
                </List>
                {promo.Href ? (
                  <LinkWrapper href={promo.Href} as={promo.As}>
                    <Button variant="contained">{promo.BtnText}</Button>
                  </LinkWrapper>
                ) : (
                  <Button variant="contained">{promo.BtnText}</Button>
                )}
              </div>
            ) : (
              <div className="more_wrapper">{moreWrapperContent()}</div>
            )}
          </Card>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
}

PromotionPage.getInitialProps = async ({ res, req, query, locale }) => {
  if (!isClient()) {
    cacheControl(res, 20);
  }

  let promo = null;

  if (!isClient() && req?.url && !req?.url.includes('/_next/')) {
    try {
      promo = await getPromo_req(req.cookies, query.promotionKey, locale);
    } catch (e) {
      console.log('PromotionPage -> getInitialProps -> gamesData Error:', e);
    }
  }

  return { promo };
};
